import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import FormControl      from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel        from '@material-ui/core/FormLabel'
import Grid             from '@material-ui/core/Grid'
import IconButton       from '@material-ui/core/IconButton'
import Radio            from '@material-ui/core/Radio'
import RadioGroup       from '@material-ui/core/RadioGroup'
import Typography       from '@material-ui/core/Typography'
import DeleteIcon       from '@material-ui/icons/Delete'
import EditIcon         from '@material-ui/icons/Edit'
import FileUploadIcon   from '@material-ui/icons/FileUpload'

import { PersonalInfo }              from '../../../api'
import { FormikFormChunkProps }      from '../../../types'
import { AbstractedFormikTextField } from '../../atoms'
import { InlineDatePicker }          from '../../atoms/DatePicker'
import ImageInput                    from '../../atoms/ImageInput'
import { Avatar }                    from '../../organisms'
import { mapFormikToMuiProps }       from '../form-utils'

const sexes = {
  m: { value: 'm', label: 'sex_M' },
  f: { value: 'f', label: 'sex_F' },
}

const CredentialsChunk: React.SFC<FormikFormChunkProps<PersonalInfo>> = props => {
  const mapper = mapFormikToMuiProps(props)

  return (
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <Typography variant={'subheading'}>
          <FormattedMessage
            id={'forms.fillInPersonalPrompt'}
            defaultMessage={'Fill in your personal information'}
          />
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          identifier={'name'}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          identifier={'surname'}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          identifier={'dni'}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          identifier={'mobile'}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          identifier={'phone'}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <InlineDatePicker
          fullWidth
          {...mapper('birthday')}
          format={'DD/MM/YYYY'}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl>
          <FormLabel component="label">
            <FormattedMessage id={'labels.sex'} />
          </FormLabel>
          <RadioGroup
            row
            name={'gender'}
            value={String(props.values.gender)}
            onChange={props.handleChange}
          >
            <FormControlLabel
              control={<Radio />}
              value={sexes.m.value}
              label={<FormattedMessage id={'labels.' + sexes.m.label} />}
              key={sexes.m.value}
            />
            <FormControlLabel
              control={<Radio />}
              value={sexes.f.value}
              label={<FormattedMessage id={'labels.' + sexes.f.label} />}
              key={sexes.f.value}
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormLabel component="label">
          <FormattedMessage id={'labels.profileImage'} />
        </FormLabel>
        <Grid container justify={'space-between'} alignItems={'center'}>
          <Grid item style={{ flex: 1 }}>
            {props.values.photo && (
              <div>
                <Avatar photo={props.values.photo} />
              </div>
            )}
          </Grid>
          {
            props.values.photo && (
              <Grid item>
                <IconButton
                  onClick={() => props.handleChange({ target: { name: 'photo', value: '' } })}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            )
          }
          <Grid item>
            <ImageInput
              onChange={base64 => props.handleChange({ target: { name: 'photo', value: base64 } })}
              id={'file-input'}
              name={'file-input'}
              accept={'image/*'}
              type={'file'}
              hidden
            />
            <label htmlFor={'file-input'}>
              <IconButton component={'span'}>
                {
                  props.values.photo
                    ? <EditIcon />
                    : <FileUploadIcon />
                }
              </IconButton>
            </label>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CredentialsChunk



// WEBPACK FOOTER //
// ./src/components/forms/chunks/PersonalInformationChunk.tsx